// extracted by mini-css-extract-plugin
export default {"header2":"Header2-module--header2--T43rG","header2--light":"Header2-module--header2--light--0urPx","header2--center":"Header2-module--header2--center--Oxec-"};